export const TWENTY_MB_IN_BYTES = 20 * 1024 * 1024;

export const FIFTY_MB_IN_BYTES = 50 * 1024 * 1024;

export const ONE_FIFTY_MB_IN_BYTES = 150 * 1024 * 1024;

export const FIVE_HUNDRED_MB_IN_BYTES = 500 * 1024 * 1024;